'use client';

import React from 'react';
import ReactPlayer from 'react-player';

interface VideoPlayerProps {
  url: string;
  width?: string | number;
  height?: string | number;
  autoplay?: boolean;
}

export default function VideoPlayer({
  url,
  width = '100%',
  height = '500px',
  autoplay = true,
}: VideoPlayerProps) {
  return (
    <ReactPlayer
      url={url}
      controls
      width={width}
      height={height}
      playing={autoplay}
      muted={autoplay}
    />
  );
}
